import { FeatureFlagIds } from "./featureFlagIds";
import { hasValue } from "@amsanalytics/react-shared-library";
import { IConfiguration } from "../Data/ConfigurationData";

export type ApplicationDownloadMode = 'report' | 'pdf' | 'hidden';

export const getApplicationDownloadMode = (
    configuration: IConfiguration | undefined,
): ApplicationDownloadMode => {
    if (configuration === undefined) return 'hidden';
    if (hasValue(configuration.applicationReport)) return 'report';
    if (configuration.featureFlags?.[FeatureFlagIds.UseApplicationReportOnly] === true) return 'hidden';
    return 'pdf';
};
